import { useSelector } from "react-redux";

export const getIsVisibleHook = ({ id }) => {
  const is_visible = useSelector(
    ({ configuration }: any) =>
      configuration?.normalisedConfig[id]?.props?.is_visible
  );

  return is_visible;
};
